import React from "react";
import PropTypes from "prop-types";
import { MyTasksColumnsContextProvider } from "./context";

export const MyTasksColumnsProvider = ({ children, columns, taskSignifiers }) => {
  return (
    <MyTasksColumnsContextProvider value={{ columns, task_signifiers: taskSignifiers }}>
      {children}
    </MyTasksColumnsContextProvider>
  );
};

MyTasksColumnsProvider.propTypes = {
  children: PropTypes.any,
  columns: PropTypes.array,
  taskSignifiers: PropTypes.array,
};
